import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { EducationSubjectService } from "../../../../auth/service/education-subject.service";
import { locale as italian } from "../../../../i18n/it";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { IDatatableConfig } from "../../../../auth/models/datatable";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { IEducationSubject } from "app/auth/models/education";

@Component({
  selector: "app-list-education-subject",
  templateUrl: "./list-education-subject.component.html",
  styleUrls: ["./list-education-subject.component.scss"],
})
export class ListEducationSubjectComponent implements OnInit {
  public config: IDatatableConfig;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public newEducationSubject: string = "";
  public currentEducationSubject: IEducationSubject;
  public educationsSubjects: IEducationSubject[];

  public showModalError: boolean = false;

  constructor(
    public _educationSubjectService: EducationSubjectService,
    public _modalService: NgbModal,
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.contentHeader = {
      headerTitle: italian.data.SCHOOL,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.SCHOOL,
            isLink: false,
          },
        ],
      },
    };
    this.config = {
      searchable: true,
      exportable: true,
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: 50,
      footerHeight: 60,
      scrollbarH: true,
      columns: [
        {
          value: "name",
          text: italian.data.FIRSTNAME,
          width: 900,
          sortable: true,
        },
      ],
    };

    if (this._utilService.isMobile) {
      this.config.columns.shift();
      this.config.columns[0].width = null;
      this.config.scrollbarH = false;
      this.config.rowHeight = 90;
    }

    await this.loadEducationSubject();
  }

  async loadEducationSubject() {
    this.educationsSubjects = await this._educationSubjectService.getList();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  educationSubjectList() {
    let items: IEducationSubject[] = this.educationsSubjects;
    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = this.educationsSubjects.filter((item: IEducationSubject) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }
    return items;
  }

  async deleteEducationSubject(currenEducation) {
    if (!this._authenticationService.hasCapability("delete_education")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currenEducation.name;
    if (currenEducation) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._educationSubjectService
            .delete(currenEducation.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadEducationSubject();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_EDUCATION_SUBJECT_REMOVE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    }
  }

  async addEducationSubject() {
    if (!this._authenticationService.hasCapability("create_education")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.newEducationSubject) {
      this.newEducationSubject = this.newEducationSubject.trim();
    }
    if (!this.newEducationSubject || this.newEducationSubject.length < 1) {
      this.showModalError = true;
      return false;
    }
    this._utilService.hideLoading();
    await this._educationSubjectService
      .create({ name: this.newEducationSubject })
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this.loadEducationSubject();
        this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_EDUCATION_SUBJECT" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDUCATION_SUBJECT_UPLOAD" });
      });
  }

  async editEducationSubject() {
    if (!this._authenticationService.hasCapability("edit_education")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!!this.currentEducationSubject.name) {
      this.currentEducationSubject.name = this.currentEducationSubject.name.trim();
    }
    if (!this.currentEducationSubject.name || this.currentEducationSubject.name.length < 1) {
      this.showModalError = true;
      return false;
    }
    this._utilService.showLoading();
    await this._educationSubjectService
      .update(this.currentEducationSubject.id, { name: this.currentEducationSubject.name })
      .then(() => {
        this._utilService.hideLoading();
        this._modalService.dismissAll();
        this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_EDUCATION_SUBJECT" });
        this.loadEducationSubject();
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_EDUCATION_SUBJECT_EDIT" });
      });
  }

  public modalOpen(whichModal, education) {
    this.newEducationSubject = "";
    this._modalService.open(whichModal, {
      size: "sm",
      centered: true,
    });
    this.currentEducationSubject = JSON.parse(JSON.stringify(education));
    this.showModalError = false;
  }
}
